import { Environment } from '../../shared/environment/environment';
import { HttpClient } from '@angular/common/http';
import { OmapiCharacteristics } from '../../model/omapi-characteristics';
import { map } from 'rxjs/operators';
import { of } from 'rxjs';
var OmapiService = /** @class */ (function () {
    function OmapiService(httpClient) {
        this.httpClient = httpClient;
    }
    OmapiService.prototype.getWeightForOmapiId = function (omapiId) {
        var omapiURL = this.getOmapiUrl(omapiId);
        return this.httpClient.get(omapiURL).pipe(map(function (response) {
            var omapiCharacteristics = new OmapiCharacteristics();
            omapiCharacteristics.weightnl = response.product.characteristics.weightnl;
            omapiCharacteristics.weightfr = response.product.characteristics.weightfr;
            return omapiCharacteristics;
        }));
    };
    OmapiService.prototype.getPackWithWeightForOmapiId = function (pack) {
        return pack ? this.getWeightForOmapiId(pack.omapiId).pipe(map(function (omapiCharacteristics) {
            if (omapiCharacteristics && omapiCharacteristics.weightnl) {
                pack.omapiCharacteristics = omapiCharacteristics;
            }
            else {
                pack.omapiCharacteristics = new OmapiCharacteristics();
                pack.omapiCharacteristics.weightnl = 0;
                pack.omapiCharacteristics.weightfr = 0;
            }
            return pack;
        })) : of(undefined);
    };
    OmapiService.prototype.getOmapiUrl = function (omapiId) {
        return Environment.environmentConfig().baseApiUrl + '/omapi/public/product/' + omapiId;
    };
    return OmapiService;
}());
export { OmapiService };
